import React, { useMemo, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import AddIcon from '@material-ui/icons/Add';
import {
  Box,
  TextField,
  Fab,
  IconButton,
  FormControl,
  FormHelperText,
  useTheme,
} from '@material-ui/core';
import { useDispatch } from 'dva';
import { useSelector, useLocation } from 'umi';
import { OPT_DETAIL } from '@/constants';
import webStorage from '@/utils/storageManager';
import CouponModal from '../CouponModal/CouponModal';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import DragContentMLStyled from './DragContentMLStyles';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  width: '100%',
  // styles we need to apply on draggables
  ...draggableStyle,
});

export default ({ num, setNum }) => {
  const location = useLocation();
  const { query } = location;
  const { opt } = query;
  const theme = useTheme();
  //礼品状态
  const ACTIVITY_POINTS_GIFT_STATUS =
    webStorage.get('DICTOBJ')?.ACTIVITY_POINTS_GIFT_STATUS;
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const { goodsShelfList, selectId, error, requireErr, isReady } = useSelector(
    (state) => state.managementGoodsShelfForm,
  );
  console.log(goodsShelfList, 'goodsShelfList');

  const goodsShelfText = useMemo(() => {
    if (selectId) {
      return goodsShelfList.find((item) => item.id === selectId)?.items;
    }
    return goodsShelfList[0]?.items;
  }, [selectId, goodsShelfList.length, num, isReady]);
  const goods = useMemo(() => {
    if (selectId) {
      return [...goodsShelfList]
        .find((item) => item.id === selectId)
        ?.items?.gifts?.map((item) => ({ ...item, id: String(item.id) }));
    }
    return [...goodsShelfList]?.[0]?.items?.gifts?.map((item) => ({
      ...item,
      id: String(item.id),
    }));
  }, [selectId, goodsShelfList.length, num, isReady]);
  const goodsSelectIds = useMemo(() => {
    if (selectId) {
      return (
        goodsShelfList
          .find((item) => item.id === selectId)
          ?.items?.gifts?.map((item) => ({ ...item, id: String(item.id) })) ||
        []
      );
    }
    return (
      goodsShelfList?.[0]?.items?.gifts?.map((item) => ({
        ...item,
        id: String(item.id),
      })) || []
    );
  }, [selectId, goodsShelfList.length, num, isReady]);
  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(goods, result.source.index, result.destination.index);
    dispatch({
      type: 'managementGoodsShelfForm/saveGoodsShelfDrag',
      payload: {
        values: {
          items,
          id: selectId ? selectId : goodsShelfList[0].id,
        },
      },
      callback: () => {
        setNum(num + 1);
      },
    });
  };
  const onConfirm = (data) => {
    dispatch({
      type: 'managementGoodsShelfForm/saveGoodsShelf',
      payload: {
        values: {
          chooseList: data,
          id: selectId ? selectId : goodsShelfList[0].id,
        },
      },
      callback: () => {
        setOpenModal(false);
        setNum(num + 1);
      },
    });
  };
  const handleClickAdd = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleDeleteGood = (id) => {
    dispatch({
      type: 'managementGoodsShelfForm/deleteGoodsShelfGift',
      payload: {
        values: {
          fId: selectId ? selectId : goodsShelfList[0].id,
          id,
        },
      },
      callback: () => {
        setNum(num + 1);
      },
    });
  };
  return (
    <DragContentMLStyled>
      <Box className="goods-shelf-text-wrap">
        <Box display="flex" flexDirection="column">
          <FormControl variant="standard">
            <TextField
              sx={{ width: '330px' }}
              variant="standard"
              label={
                <>
                  <span style={{ color: 'red' }}>*</span>
                  子货架名称
                </>
              }
              onChange={(e) => {
                // let v = e.target.value;
                dispatch({
                  type: 'managementGoodsShelfForm/saveTitle',
                  payload: {
                    values: {
                      val: e.target.value,
                      id: selectId ? selectId : goodsShelfList[0].id,
                    },
                  },
                  callback: () => {
                    setNum(num + 1);
                  },
                });
              }}
              value={goodsShelfText.title}
              error={error === 1 || error === 2 || requireErr === 1}
              disabled={opt === OPT_DETAIL}
            />
          </FormControl>
          {(error === 1 || error === 2 || requireErr === 1) && (
            <FormHelperText
              error={error === 1 || error === 2 || requireErr === 1}
            >
              {requireErr === 1 ? '子货架名称是必填项' : '输入不超过15个字符'}
            </FormHelperText>
          )}
        </Box>
        <Box display="flex" flexDirection="column">
          <FormControl variant="standard">
            <TextField
              sx={{ width: '330px' }}
              variant="standard"
              label="子货架副标题"
              onChange={(e) => {
                // let v = e.target.value;
                dispatch({
                  type: 'managementGoodsShelfForm/saveSubTitle',
                  payload: {
                    values: {
                      val: e.target.value,
                      id: selectId ? selectId : goodsShelfList[0].id,
                    },
                  },
                  callback: () => {
                    setNum(num + 1);
                  },
                });
              }}
              value={goodsShelfText.subTitle}
              error={error === 1 || error === 3}
              disabled={opt === OPT_DETAIL}
            />
          </FormControl>
          {(error === 1 || error === 3) && (
            <FormHelperText error={error === 1 || error === 3}>
              输入不超过15个字符
            </FormHelperText>
          )}
        </Box>
      </Box>
      <div className="export-wrapper">
        <Box className="gift-title">礼品</Box>
        {opt !== OPT_DETAIL && (
          <Fab
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            className="export"
            sx={{ marginRight: '16px' }}
            onClick={handleClickAdd}
          >
            <AddIcon sx={{ width: '24px', height: '24px' }} />
            添加
          </Fab>
        )}
      </div>
      <Box>
        <Box>
          <Box className="table-wrap">
            <Box className="table-th table-th-shrink" width="320px">
              礼品code
            </Box>
            <Box className="table-th" width="100%">
              礼品标题
            </Box>
            <Box className="table-th" width="100%">
              有效期
            </Box>
            <Box className="table-th table-th-shrink" width="255px">
              礼品状态
            </Box>
            <Box className="table-th table-th-shrink" width="120px">
              操作
            </Box>
          </Box>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  {goods.map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided1, snapshot1) => (
                        <div
                          ref={provided1.innerRef}
                          {...provided1.draggableProps}
                          {...provided1.dragHandleProps}
                          style={{
                            ...getItemStyle(
                              snapshot1.isDragging,
                              provided1.draggableProps.style,
                            ),
                          }}
                        >
                          <Box className="table-wrap table-wrap-background">
                            <Box
                              className="table-th table-th-shrink"
                              width="320px"
                            >
                              {item.code}
                            </Box>
                            <Box className="table-th" width="100%">
                              {item.title}
                            </Box>
                            <Box className="table-th" width="100%">
                              {item.expirationDate}
                            </Box>
                            <Box
                              className="table-th table-th-shrink"
                              width="255px"
                            >
                              {
                                ACTIVITY_POINTS_GIFT_STATUS?.find(
                                  (i) => i.nameEn === item.status,
                                )?.nameZh
                              }
                            </Box>
                            <Box
                              className="table-th table-th-shrink"
                              width="120px"
                              display="flex"
                              justifyContent="center"
                            >
                              <ButtonTip title="删除">
                                <IconButton
                                  aria-label="account of current user"
                                  aria-controls="menu-appbar"
                                  aria-haspopup="true"
                                  color="inherit"
                                  onClick={() => {
                                    handleDeleteGood(item.id);
                                  }}
                                  disabled={opt === OPT_DETAIL}
                                >
                                  <SvgIconML
                                    name="circleDelete"
                                    size={24}
                                    // fill={theme.palette.primary.main}
                                    fill={
                                      opt !== OPT_DETAIL
                                        ? '#1B60AD'
                                        : theme.palette.secondary.disabled
                                    }
                                    className="preview"
                                  />
                                </IconButton>
                              </ButtonTip>
                            </Box>
                          </Box>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Box>
      </Box>
      {openModal && (
        <CouponModal
          open={openModal}
          onClose={handleCloseModal}
          onConfirm={onConfirm}
          selectedIds={goodsSelectIds ? goodsSelectIds : []}
        />
      )}
    </DragContentMLStyled>
  );
};
